import { useNavigate } from 'react-router-dom';
import { AuthLayout, AuthPromoPanel, RegisterForm } from '@practium/features/auth';
import { BarChart } from '@mui/icons-material';

export const RegisterPageClient = () => {
	const navigate = useNavigate();

	return (
		<AuthLayout
			title="Criar Conta"
			subtitle={
				<>
					Já tem uma conta?{' '}
					<a href="/login" style={{ color: 'var(--primary)', textDecoration: 'underline', fontWeight: 500 }}>
						Faça login
					</a>
				</>
			}
			promoPanel={
				<AuthPromoPanel
					promoImageSrc="/images/register-promo-image.jpg"
					promoTitle="Inteligência Artificial"
					promoDescription="O Practium utiliza a Flora, a Inteligência Artificial treinada por especialistas."
					statsCard={{ icon: <BarChart />, label: 'Economia', value: 'R$75 040' }}
					sectionHeading="Controle total da operação"
					sectionText="Acompanhe produção, custos e resultados em tempo real."
				/>
			}
		>
			<RegisterForm
				onSuccess={() => navigate('/')}
				onGoogleSuccess={() => navigate('/')}
				onAutoLoginFailed={() => navigate('/login')}
			/>
		</AuthLayout>
	);
};
